import axios from '@/axios/api.request'

export const save = (from) => axios.request({
    url: 'office/work/setting/save',
    data: from,
    method: 'post'
})
